import { AnimatedCheck } from "common/Icons/Icons";
import { useTheme } from "styled-components";

interface AnimatedCheckIconProps {
  size: number;
  color?: string;
}

const AnimatedCheckIcon = ({ size, color }: AnimatedCheckIconProps) => {
  const theme = useTheme();
  return (
    <AnimatedCheck
      height={size}
      width={size}
      style={{
        color: color ?? theme.colors.green,
      }}
    />
  );
};

export default AnimatedCheckIcon;
